import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { BaseApiService } from "@app/shared/services/base-api.service";
import { CountyMasterDto, StateMasterDto } from "@shared/models";

@Injectable({
  providedIn: "root",
})
export class StateMasterApiService extends BaseApiService {
  protected readonly endpoint = "/config/StateMaster";
  protected readonly microservice = "configServ" as const;

  /**
   * GET /api/config/StateMaster/GetAllActiveState
   */
  getAllActiveStates(): Observable<StateMasterDto[]> {
    return this.get<StateMasterDto[]>("/GetAllActiveState");
  }

  /**
   * GET /api/config/StateMaster/GetCountiesByStateCode/{stateCode}
   */
  getCountiesByStateCode(stateCode: string): Observable<CountyMasterDto[]> {
    return this.get<CountyMasterDto[]>(`/GetCountiesByStateCode/${stateCode}`);
  }
}
